import * as React from "react";
import styled, { css, keyframes } from "~/styled";

export enum StepState {
  PENDING = "pending",
  ACTIVE = "active",
  DONE = "done"
}

interface IProps {
  status: StepState;
  icon: React.ComponentType;
  title: string;
}

const ItemWrapper = styled.div<{ status: StepState }>`
  display: grid;
  justify-items: center;
  grid-row-gap: 12px;
  grid-template-rows: 24px 20px auto;
  grid-template-areas:
    "icon"
    "indicator"
    "title";

  color: ${props =>
    props.status === "active" ? "rgb(51, 51, 51)" : "rgba(51, 51, 51, 0.7)"};
`;

const Title = styled.span`
  text-align: center;
  grid-area: title;
  font-size: 12px;

  @media (max-width: 568px) {
    display: none;
  }
`;

const IconWrapper = styled.div`
  grid-area: icon;
  color: #555;
`;

const pulsate = keyframes`
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.2);
  }
`;

const Indicator = styled.div<{ status: StepState }>`
  align-self: center;
  grid-area: indicator;
  border-radius: 100%;
  position: relative;
  z-index: 1;
  ${props =>
    props.status === "active"
      ? css`
          height: 20px;
          width: 20px;
          animation: ${pulsate} 1s ease infinite alternate;
        `
      : css`
          height: 14px;
          width: 14px;
        `}
  background-color: ${props =>
    props.status === "pending" ? "#eee" : props.theme.brandColor.primary};
`;

const Bar = styled.div<{ status: StepState }>`
  grid-area: indicator;
  height: 8px;
  width: calc(100% + 24px);
  background-color: ${props =>
    props.status === "done" ? props.theme.brandColor.primary : "#eee"};
  align-self: center;
  transform: translateX(50%);

  ${ItemWrapper}:last-child & {
    display: none;
  }
`;

export class ProgressItem extends React.Component<IProps> {
  public render() {
    const { icon: Icon, status, title, ...rest } = this.props;

    return (
      <ItemWrapper status={status} {...rest}>
        <IconWrapper>
          <Icon />
        </IconWrapper>
        <Indicator status={status} />
        <Bar status={status} />
        <Title>{title}</Title>
      </ItemWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TrackTrace/ProgressItem.tsx